import React, { useState } from 'react';
import { withNamespaces, Trans } from 'react-i18next';
import storage from 'core/localStorage';
import { staticURL } from 'core/url';

import Heading from 'components/Heading';
import Paragraph from 'components/Paragraph';
import Button from 'components/Button';

import {
  LargePanelSectionWrapper,
  CollapseWrapper,
  ContentWrapper,
  IllustrationWrapper,
} from './onboarding.styled';

const keyOnboarding = 'marketplace-onboarding';

const Onboarding = () => {
  const init = () => {
    const data = storage.get(keyOnboarding);
    if (!data) {
      storage.set(keyOnboarding, { show: true }, true);
      return true;
    }

    if (data) return data?.show;

    return false;
  };

  const [showContent, setShowContent] = useState(init());

  const clickHide = () => {
    storage.set(keyOnboarding, { show: false }, true);
    setShowContent(false);
  };

  const clickShow = () => {
    storage.set(keyOnboarding, { show: true }, true);
    setShowContent(true);
  };

  const tagline = (
    <Paragraph>
      <Trans>Place an order, and have parts delivered to your doorstep.</Trans>
    </Paragraph>
  );

  return (
    <LargePanelSectionWrapper first>
      <Heading level='1' size='xlarge' margin='0 0 1rem 0'>
        <Trans>Get a quote in 24h</Trans>
      </Heading>
      {showContent ? (
        <CollapseWrapper>
          <ContentWrapper>
            {tagline}
            <Paragraph>
              <Trans>
                One of our Manufacturing Experts will evaluate your RFQ, and
                match-make you with a quality assured manufacturers from our
                network.
              </Trans>
            </Paragraph>
            <Paragraph>
              <Trans>
                Wikifactory Marketplace™ handles your manufacturing needs online
                from payments to communications with the manufacturer. It
                includes DFM feedback, engineering support, +150 materials, and
                global delivery.
              </Trans>
            </Paragraph>
            <Button
              size='small'
              appearance='plain'
              variant='tertiary'
              margin='default 0'
              icon='close_small'
              iconPosition='left'
              text={<Trans>{`Don't show this again.`}</Trans>}
              onClick={clickHide}
            />
          </ContentWrapper>
          <IllustrationWrapper>
            <img
              src={staticURL('assets/marketplace/onboarding.svg')}
              alt='Abstract geometric illustration'
            />
          </IllustrationWrapper>
        </CollapseWrapper>
      ) : (
        <CollapseWrapper>
          <ContentWrapper>
            {tagline}
            <Button
              size='small'
              appearance='plain'
              icon='info'
              iconPosition='left'
              variant='tertiary'
              margin='default 0'
              text={<Trans>{`Learn more.`}</Trans>}
              onClick={clickShow}
            />
          </ContentWrapper>
        </CollapseWrapper>
      )}
    </LargePanelSectionWrapper>
  );
};

export default withNamespaces()(Onboarding);
